module.exports = __webpack_public_path__ + "static/media/first-offers-bg.2473f099.png";